import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { fomateDate } from '../../utils/fomateDate';
import Operations from '../reusable/Operations';
import { useNavigate } from 'react-router-dom';
import { deleteManufacturerThunk, deletemultipleManufacturer, setEditManufacturer, setSelectallmanufacturer, setSelectedmanufacturerids } from '../../redux/manufacturer/getAllManufacturerSlice';
import { MultipleDeletes } from '../../Svg';
// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: '600',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '8px 0px 8px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,
  fontSize: '15px',
}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
  fontSize: '15px',
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#1D1F2C',
  fontWeight: '600',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
  fontSize: '15px',
}));

const InactiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ffc9c9',
  color: '#d9534f',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#d4edda',
  color: '#28a745',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));




const ManufacturersTable = ({ Manufacturer, start, end, setPage, page, itemsPerPage, totalItems, handleOpenMenu }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bulkDelete, setBulkDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null)

  const { selectedIds, selectAll } = useSelector((state) => state.manufacturer);

  const navigate = useNavigate()
  const dispatch = useDispatch()


  const deleteCategory = (password) => {
    if (bulkDelete) {
      dispatch(deletemultipleManufacturer({ ids: selectedIds, password }))
      setBulkDelete(false)
    } else {
      dispatch(deleteManufacturerThunk({ id: selectedId, password }))
    }
    setIsModalOpen(false);

  }



  const handleDeleteClick = (id) => {
    setSelectedId(id)
    setIsModalOpen(true);
  };

  const handleEditClick = (category) => {
    dispatch(setEditManufacturer(category));
    navigate('/master/editManufacturers')
  };



   const handleSelect = (id) => {
        const isExist = selectedIds.includes(id)
        if (isExist) {
          const filter = selectedIds?.filter(i => i !== id)
          return dispatch(setSelectedmanufacturerids(filter))
        }
        const data = [...selectedIds, id]
        dispatch(setSelectedmanufacturerids(data))
      }
    
    
      const handleSelectAll = () => {
        if (!selectAll) {
          const ids = Manufacturer?.map(i => i?._id)
          dispatch(setSelectedmanufacturerids(ids))
          return dispatch(setSelectallmanufacturer(true))
        }
        dispatch(setSelectedmanufacturerids([]))
        dispatch(setSelectallmanufacturer(false))
      }
    
      // Bulk delete asks for the Super Admin password in the same box first
      const handleMultipledelete = () => {
        setBulkDelete(true)
        setIsModalOpen(true)
      }
  


  return (
    <>
      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>



              <HeaderCell>
                <IconButton>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </IconButton>
                Manufacture
                <IconButton onClick={(e) => handleOpenMenu('name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Products
                <IconButton onClick={(e) => handleOpenMenu('products')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('thumbnail.status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Added
                <IconButton onClick={(e) => handleOpenMenu('createdAt')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
                {selectedIds?.length > 0 &&
                  <IconButton onClick={handleMultipledelete}>
                    <MultipleDeletes />
                  </IconButton>
                }
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {Manufacturer.map((row) => (
              <TableRow key={row._id}>

                <TableCells sx={{
                  width: '25%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <input
                        type="checkbox"
                        checked={selectedIds.find(i => i == row?._id)}
                        onChange={() => handleSelect(row?._id)}
                      />
                    </div>
                    <div>
                      {
                        (row?.thumbnail?.photo?.[0] || (typeof row?.thumbnail?.photo === 'string' && row?.thumbnail?.photo)) ? (
                          <img
                            src={Array.isArray(row?.thumbnail?.photo) ? row.thumbnail.photo[0] : row?.thumbnail?.photo}
                            alt={row.name}
                            style={{ width: 44, height: 44, borderRadius: 2, objectFit: 'contain' }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/assets/profile.png";
                            }}
                          />
                        ) : (
                          <img src="/assets/profile.png" alt="default" style={{ width: 44, height: 44, borderRadius: 2 }} />
                        )
                      }
                    </div>

                    <div>
                      <strong style={{ color: '#1D1F2C', fontSize: '15px', fontWeight: '600' }}>{row.name}</strong>
                      {row.description && (
                        <div style={{ fontSize: '13px', color: '#667085', fontWeight: '400', marginTop: '2px' }}>
                          {row.description}
                        </div>
                      )}
                    </div>
                  </div>
                </TableCells>

                <ProductText sx={{ width: '13%' }}>{row.productCount}</ProductText>

                <TableCells sx={{ width: '13%' }}>
                  {row?.thumbnail?.status === "ACTIVE" ? (
                    <ActiveChip label="Active" size="small" />
                  ) : (
                    <InactiveChip label="Inactive" size="small" />
                  )}
                </TableCells>

                <TableCells sx={{ width: '13%', fontSize: '15px', color: '#495057', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells>

                <Operations
                  TableCells={TableCells}
                  viewClick={() => navigate(`/master/viewManufacturers/${row?._id}`)}
                  editClick={() => handleEditClick(row)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'Manufacturer'}
                  onClose={() => { setIsModalOpen(false); setBulkDelete(false) }}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default ManufacturersTable;
